import React from 'react';
import { ItineraryTypes } from '../types';
import { ItemMedia } from './ItemMedia';
import { StayBadge } from 'ui/StayBadge/StayBadge';
import { VerticalSpace } from 'ui/VerticalSpace';
import { ItemNotesAndAttachments } from './ItemNotesAndAttachments';
import { SeeMoreCollapsible } from 'ui/SeeMoreCollapsible';
import { HtmlStringRenderer } from 'components/HtmlStringRenderer';

export interface iAccommodationProps {
  item: ItineraryTypes['ItineraryItem'];
  roomRelativeIndex: number;
}

export const Accommodation = (props: iAccommodationProps) => {
  const { item } = props;

  const ancillaryDescription = item.ancillary_description;

  const numberOfAdults = item.numberOfAdults || 0;
  const agesOfAllChildren = item.agesOfAllChildren || [];

  const mealPlan = item.subItems.find(subItem => subItem.subItemType === 'mealPlan');
  const mealPlanCategoryType = mealPlan?.categoryType;
  return (
    <div>
      {/* row 1 is a grid thing */}
      <div className={`grid grid-cols-1 md:grid-cols-2 mb-10px gap-5px`}>
        <h2 className="m-0 font-hurmegeometric-sans uppercase text-flint text-[14px]">
          Room #{props.roomRelativeIndex} {item.title}
        </h2>

        <StayBadge className="md:justify-self-end" startDate={item.date!} endDate={item.endDate!} />

        {(numberOfAdults > 0 || agesOfAllChildren.length > 0 || mealPlanCategoryType) && (
          <>
            <div className="hidden md:block">{/* deliberately blank */}</div>
            <span className="flex items-center gap-4 font-hurmegeometric-sans text-14px text-flint uppercase md:justify-self-end">
              {numberOfAdults > 0 && <span>{numberOfAdults} ADULT</span>}
              {agesOfAllChildren.length > 0 && <span>{agesOfAllChildren.length} CHILD</span>}

              {mealPlanCategoryType && <span>Basis: {mealPlanCategoryType}</span>}
            </span>
          </>
        )}
      </div>

      {/* the media */}
      <ItemMedia
        vimeoVideoId={item.vimeoVideoId}
        uploads={item.uploads as ItineraryTypes['ItineraryImageUploadOrThumbnail'][]}
        titleForModal={item.title}
      />

      <VerticalSpace height="10px" />

      <SeeMoreCollapsible>
        <div className="flex flex-col gap-4">
          {ancillaryDescription && (
            <HtmlStringRenderer 
              content={ancillaryDescription}
              className="block font-hurmegeometric-sans text-14px text-flint"
              fallbackComponent="span"
            />
          )}

          {!ancillaryDescription && item.be_description && (
            <HtmlStringRenderer 
              content={item.be_description}
              className="block font-hurmegeometric-sans text-14px text-flint"
              fallbackComponent="span"
            />
          )}

          {item.be_meta_moreInformation && (
            <div>
              <span className="block uppercase font-hurmegeometric-sans text-14px text-flint leading-22px">
                Room Benefits:
              </span>
              <HtmlStringRenderer 
                content={item.be_meta_moreInformation || ''}
                className="font-hurmegeometric-sans text-14px text-flint leading-22px"
                fallbackComponent="span"
              />
            </div>
          )}
          {(item.be_meta_amenities || []).length >= 1 && (
            <div>
              <span className="block uppercase font-hurmegeometric-sans text-14px text-flint leading-22px">
                amenities:
              </span>
              <span className="block font-hurmegeometric-sans text-14px text-flint leading-22px">
                Room Size: {item.be_meta_size} square metres
              </span>
              <HtmlStringRenderer 
                content={item.be_meta_amenities || ''}
                className="block font-hurmegeometric-sans text-14px text-flint leading-22px"
                fallbackComponent="span"
              />
            </div>
          )}
        </div>
      </SeeMoreCollapsible>

      <VerticalSpace height="10px" />

      {(item.notes.length > 0 || item.uploads.length > 0) && (
        <>
          <VerticalSpace height="10px" />
          <ItemNotesAndAttachments notes={item.notes} uploads={item.uploads} />
          <VerticalSpace height="40px" />
        </>
      )}

      {item.notes.length === 0 && item.uploads.length === 0 && (
        <>
          <VerticalSpace height="40px" />
        </>
      )}
    </div>
  );
};
